import { useTranslation } from 'react-i18next';
import { SocialAccountInfluencerListSortFieldV2, Order } from '@anytag/graphql';
import { SortOption } from '@anytag/shared-types';
import { InfluencerSortActionBarTemplate, InfluencersSortTemplate } from '../../shared';
import { useTiktokInfluencersContext } from '../TiktokInfluencersContext';

export const TiktokInfluencersSort = () => {
  const { t } = useTranslation();
  const { sort, limit, setSort, setLimit, isEngagementPage, sortSelectButtonProps } = useTiktokInfluencersContext();

  const sortOptions: SortOption<SocialAccountInfluencerListSortFieldV2>[] = [
    {
      order: Order.ASC,
      label: t('Follower (ASC)'),
      field: SocialAccountInfluencerListSortFieldV2.SOCIAL_ACCOUNT_FOLLOWERS
    },
    {
      order: Order.DESC,
      label: t('Follower (DESC)'),
      field: SocialAccountInfluencerListSortFieldV2.SOCIAL_ACCOUNT_FOLLOWERS
    },
    {
      order: Order.ASC,
      label: t('ER by views (ASC)'),
      field: SocialAccountInfluencerListSortFieldV2.SOCIAL_ACCOUNT_ENGAGEMENT_VIEWS_RATE
    },
    {
      order: Order.DESC,
      label: t('ER by views (DESC)'),
      field: SocialAccountInfluencerListSortFieldV2.SOCIAL_ACCOUNT_ENGAGEMENT_VIEWS_RATE
    },
    {
      order: Order.ASC,
      label: t('ER by followers (ASC)'),
      field: SocialAccountInfluencerListSortFieldV2.SOCIAL_ACCOUNT_ENGAGEMENT_FOLLOWERS_RATE
    },
    {
      order: Order.DESC,
      label: t('ER by followers (DESC)'),
      field: SocialAccountInfluencerListSortFieldV2.SOCIAL_ACCOUNT_ENGAGEMENT_FOLLOWERS_RATE
    },
    { order: Order.ASC, label: t('Avg View (ASC)'), field: SocialAccountInfluencerListSortFieldV2.AVG_VIEW },
    { order: Order.DESC, label: t('Avg View (DESC)'), field: SocialAccountInfluencerListSortFieldV2.AVG_VIEW },
    { order: Order.ASC, label: t('Avg Like (ASC)'), field: SocialAccountInfluencerListSortFieldV2.AVG_LIKE },
    { order: Order.DESC, label: t('Avg Like (DESC)'), field: SocialAccountInfluencerListSortFieldV2.AVG_LIKE }
  ].map((option) => ({ ...option, value: `${option.field}-${option.order}` }));

  return (
    <div className="filter-sort-container">
      <InfluencersSortTemplate
        setSort={setSort}
        setLimit={setLimit}
        sortOptions={sortOptions}
        selectButtonProps={sortSelectButtonProps}
        initialValues={{ sort, limit: String(limit) }}
      />

      {!isEngagementPage && sortSelectButtonProps?.checked ? (
        <InfluencerSortActionBarTemplate selectButtonProps={sortSelectButtonProps} />
      ) : null}
    </div>
  );
};
